/* eslint-disable no-shadow */
import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import Datepicker from 'react-datepicker';
import { orderBy } from 'lodash';
import styles from './scheduleTab.scss';

import OrderOfPlayGrid from './OrderOfPlayGrid';

const _ = { orderBy };

const CustomInput = forwardRef(({ value, onClick }, ref) => {
    const formattedDate = value ? moment(value).format('MMM D, YYYY') : 'Select Date';
    return (
        <div
            className={`${styles.customDatepickerInputOop}`}
            onClick={onClick}
            ref={ref}
        >
            <span>{formattedDate}</span>
            <img src="/img/icons/datepicker-icon.svg" alt="calendar icon" />
        </div>
    );
});

CustomInput.propTypes = {
    value: PropTypes.instanceOf(Date),
    onClick: PropTypes.func.isRequired,
};

CustomInput.defaultProps = {
    value: null,
};

const OrderOfPlayV2 = (props) => {
    const { onPrintPage } = props;
    const auth = useSelector(({ auth }) => auth);
    const { event, orderOfPlaySchedule, locations } = useSelector(({ eventProfile }) => {
        const { event, orderOfPlaySchedule, locations } = eventProfile;
        return { event, orderOfPlaySchedule, locations };
    });

    const { timeZone, eventStartUtc, eventEndUtc } = event.data.eventSchedule;
    const defaultDate = moment().utc().isBefore(eventStartUtc) || moment().utc().isAfter(eventEndUtc) ? moment(eventStartUtc).tz(timeZone.value) : moment().tz(timeZone.value);
    const [date, setDate] = useState(moment(defaultDate));
    const [facilityList, setFacilityList] = useState([]);
    const [facilityId, setFacilityId] = useState('');
    const history = useHistory();

    useEffect(() => {
        const matches = orderOfPlaySchedule?.data?.matches ?? [];
        const facilityIds = [...new Set(matches.map(m => m.facilityId).filter(Boolean))];
        const nameByFacilityId = {};
        (locations?.data || []).forEach(loc => {
            const locFacilities = loc.facilities ?? [];
            locFacilities.forEach(fac => {
                if (facilityIds.includes(fac.id)) {
                    nameByFacilityId[fac.id] = fac.name;
                }
            });
        });
        matches.forEach(m => {
            const id = m.facilityId;
            if (id && nameByFacilityId[id] == null && m.matchDetails) {
                nameByFacilityId[id] = m.matchDetails.facilityName;
            }
        });
        let fList = facilityIds.map(id => ({ id, name: nameByFacilityId[id] || id }));
        fList = _.orderBy(fList, [f => (f.name || '').toLowerCase()]);
        setFacilityList(fList);
        setFacilityId((prevId) => {
            if (prevId) {
                return prevId;
            }
            return fList[0]?.id ?? '';
        });
    }, [locations.data, orderOfPlaySchedule?.data]);

    const printSchedule = () => {
        if (onPrintPage) {
            window.print();
        } else {
            history.push(`/order-of-play/print`);
        }
    };

    const handleDateChange = (value) => {
        setDate(value);
    };

    const handleFacilityChange = (e) => {
        setFacilityId(e.target.value);
    };

    if (locations.data !== null && event.data.id) {
        return (
            <>
                <div className="row mt16">
                    <div className="col-md-8 d-flex">
                        <div className="form-inline">
                            <div className={`form-group form-group-inline`}>
                                <div className="input-wrapper mr8">
                                    <Datepicker
                                        className="form-control form-control-sm"
                                        selected={date}
                                        onChange={handleDateChange}
                                        minDate={moment.utc(eventStartUtc)}
                                        maxDate={moment.utc(eventEndUtc)}
                                        customInput={<CustomInput />}
                                    />
                                </div>
                                <div className="input-wrapper mr8">
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            className={`${styles.customFacilitiesSelect} `}
                                            value={facilityId}
                                            onChange={handleFacilityChange}
                                            disabled={facilityList.length <= 1}
                                        >
                                            {facilityList.length !== 1 && <option>Choose facilities...</option>}
                                            {facilityList.map((fac) => (
                                                <option key={fac.id} value={fac.id}>{fac.name}</option>
                                            ))}
                                        </select>
                                        <div className={`${styles.customDropdownIcon}`}>
                                            <img
                                                src="/img/icons/dropdown-icon.svg"
                                                alt="dropdown icon"
                                                style={{ width: '10px', height: '5px' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 d-none d-md-flex aic jce">
                        {auth?.user && (
                            <button
                                type="button"
                                className={`${styles.customPrintBtn} btn btn-small btn-default float-right no-print `}
                                onClick={printSchedule}
                            >
                                Print
                            </button>
                        )}
                    </div>
                </div>
                <div className={`bg-transparent main-content`}>
                    <OrderOfPlayGrid
                        orderOfPlaySchedule={orderOfPlaySchedule}
                        facilityId={facilityId}
                        timeZone={timeZone}
                        date={date}
                    />
                </div>
            </>
        );
    }
    return null;
};

export default OrderOfPlayV2;
